// src/App.tsx
import React from "react";
import Home from "./pages/Home";
import NavBar from "./components/common/NavBar";
import MobileNavBar from "./components/common/MobileNavBar";
import { CssBaseline } from "@mui/material";
import ThemeProvider from "./themes/CustomTheme"; // Adjust the path accordingly
import { AuthProvider } from "./context/AuthContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import NotFound from "./pages/NotFound";
import BlogPage from "./pages/Blog";
import ProductView from "./pages/Product/view";
import BlogView from "./pages/Blog/view";
import { useScrollHandler } from "./hooks/useScrollHandler";
import { useScrollToTop } from "./hooks/useScrollToTop";
import SellerProfile from "./pages/Seller/profile";
import ProductByCategory from "./pages/Product/ProductByCategory";
import Account from "./pages/Users/account";
import Presell from "./pages/Seller/presell";
import SellerSetup from "./pages/Seller/seller-setup";
import Sell from "./pages/Seller/sell";
import { useDeleteLoginSession } from "./hooks/useDeleteLoginSession";
import Confirm from "./pages/confirm";
import useBotProtection from "./hooks/useBotProtection";
import Blackhole from "./pages/blackhole";

export interface IRoutes {
  HOME: string;
  BLOG: string;
  BLOG_VIEW: string;
  PRODUCT_VIEW: string;
  SELLER_PROFILE: string;
  PRODUCT_CATEGORY: string;
  PRODUCT_SUBCATEGORY: string;
  USER_ACCOUNT: string;
  SELLER_PRESELL: string;
  SELLER_SETUP: string;
  SELL: string;
  CONFIRM_ACCOUNT: string;
  BLACK_HOLE: string;
}

export const DEFINED_ROUTES: IRoutes = {
  HOME: "/",
  BLOG: "/blog",
  BLOG_VIEW: "/blog/:id",
  PRODUCT_VIEW: "/:category/:subCategory/:name",
  SELLER_PROFILE: "/u/:profileId/profile",
  PRODUCT_CATEGORY: "/:category",
  PRODUCT_SUBCATEGORY: "/:category/:subCategory",
  USER_ACCOUNT: "/account",
  SELLER_PRESELL: "/presell",
  SELLER_SETUP: "/seller-setup",
  SELL: "/sell",
  CONFIRM_ACCOUNT: "/confirm-account/:id/:email",
  BLACK_HOLE: "/black-hole",
};

const App: React.FC = () => {
  useBotProtection();
  useScrollHandler(DEFINED_ROUTES);
  useScrollToTop();
  useDeleteLoginSession();
  const location = useLocation();

  // Check if the current route matches the BLACK_HOLE path
  const isBlackHoleRoute = location.pathname === DEFINED_ROUTES.BLACK_HOLE;

  return (
    <AuthProvider>
      <ThemeProvider>
        <CssBaseline />
        <div className="global-container">
          {/* {!isBlackHoleRoute && ( */}
          <NavBar
            onSearch={(query) => console.log("Searching for:", query)}
            onLogin={() => console.log("Logging in")}
            onSell={() => console.log("Selling")}
            userName="John Doe"
          />
          {/* )} */}
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path={DEFINED_ROUTES.HOME} element={<Home />} />
            <Route path={DEFINED_ROUTES.SELL} element={<Sell />} />
            <Route path={DEFINED_ROUTES.BLOG} element={<BlogPage />} />
            <Route path={DEFINED_ROUTES.BLOG_VIEW} element={<BlogView />} />
            <Route
              path={DEFINED_ROUTES.PRODUCT_VIEW}
              element={<ProductView />}
            />
            <Route
              path={DEFINED_ROUTES.SELLER_PROFILE}
              element={<SellerProfile />}
            />
            <Route
              path={DEFINED_ROUTES.PRODUCT_CATEGORY}
              element={<ProductByCategory />}
            />
            <Route
              path={DEFINED_ROUTES.PRODUCT_SUBCATEGORY}
              element={<ProductByCategory />}
            />
            <Route path={DEFINED_ROUTES.USER_ACCOUNT} element={<Account />} />
            <Route path={DEFINED_ROUTES.SELLER_PRESELL} element={<Presell />} />
            <Route path={DEFINED_ROUTES.SELLER_SETUP} element={<SellerSetup />} />
            <Route
              path={DEFINED_ROUTES.CONFIRM_ACCOUNT}
              element={<Confirm />}
            />
            {/* <Route path={DEFINED_ROUTES.BLACK_HOLE} element={<Blackhole />} /> */}
          </Routes>
          {/* {!isBlackHoleRoute && */}
          <MobileNavBar />
          {/*} */}
        </div>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
